function _(t,n,a){var r=2*Math.PI,o=t(45);n.exports=function(t){return Math.abs(t)<=3.14159265359?t:t-o(t)*r}}
//# sourceMappingURL=adjust_lon.min.js.map